import application from "stimulus_application";
import LogosController from "./logos_controller";
import "./logos.css";

application.register("logos", LogosController);
